"use strict";
const styles_1 = require('material-ui/styles');
const c = require('./colors');
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = styles_1.getMuiTheme({
    palette: {
        primary1Color: c.blue,
    },
});



/** WEBPACK FOOTER **
 ** ./src/components/theme/muiTheme.ts
 **/